<template>
      <div id="quiz-content" class="grid-container fluid" :class="(questions[questionIndex].name).replace(/\s+/g, '-').toLowerCase()">
            <div id="questions"  class="grid-x grid-padding-x align-center-middle" :class="[dropClass ? 'show-drop' : 'hide-drop']">
                  <div class="detect-overlay" @click="dropDown()" v-if="dropClass"></div>
                  <div class="cell small-12 large-8">
                        <div class="question-container">
                              <div class="progress-container" :class="questions[questionIndex].theme">
                                    <div class="progress">
                                          <div class="progress-meter progress-meter1"></div>
                                    </div>
                                    <div class="progress">
                                          <div class="progress-meter progress-meter2"></div>
                                    </div>
                                    <div class="progress">
                                          <div class="progress-meter progress-meter3"></div>
                                    </div>
                                    <div class="progress">
                                          <div class="progress-meter progress-meter4"></div>
                                    </div>
                                    <div class="progress">
                                          <div class="progress-meter progress-meter5"></div>
                                    </div>
                              </div>
                              <h1 class="text-center">
                                    <strong>{{quizTitle}}</strong>
                                    <div v-if="questionIndex!==0">
                                          <span class="subzip animate__animated animate__fadeIn animate__faster">ZIP code: {{zipCode}}</span>
                                    </div>
                              </h1>
                              <transition name="custom-classes-transition" enter-active-class="animate__animated animate__fadeIn animate__faster" leave-active-class="animate__animated animate__fadeOut animate__faster" mode="out-in">
                                    <div class="question" v-bind:key="questionIndex">
                                          <div class="detect-overlay" @click="dropDown()" v-if="dropClass"></div>
                                          <div class="question-icon text-center" v-if="questionIndex===3 || questionIndex===6 || questionIndex===7 || questionIndex===8 || questionIndex===9">
                                                <img v-bind:src="questions[questionIndex].icon" width="100"/>                                                
                                          </div>
                                          <h2 class="text-center" v-html="questions[questionIndex].title"></h2>
                                          <p class="text-center h4 subtext" v-html="questions[questionIndex].text"></p>
                                          <div v-if="questionIndex===3 || questionIndex===6 || questionIndex===7 || questionIndex===8 || questionIndex===9">
                                                <p class="mb0 text-center mt32 h4"><strong><router-link to="/" class="underline">Exit</router-link> to return to the main page or <a @click="goBack()" class="underline">check another ZIP code</a></strong></p>
                                          </div>
                                          <div v-if="questionIndex===3 || questionIndex===6 || questionIndex===8 || questionIndex===9">
                                                <p class="mb0 text-center mt32 bottom-text">{{questions[questionIndex].ps}}</p>
                                          </div>
                                          <div class="grid-container" v-if="questionIndex===0">
                                                <div class="grid-x grid-padding-x align-center" >
                                                      <div class="cell small-12 medium-6">
                                                            <input v-model="zipCode" type="text" placeholder="Enter your ZIP code" maxlength="5" class="animate__animated animate__fast" :class="zipClass" @keyup.enter="checkZip()">
                                                            <p class="error animate__animated animate__fast h5" :class="zipClass" v-if="checkZip"><em>Please enter a valid ZIP code.</em></p>
                                                      </div>
                                                      <div class="cell medium-shrink large-shrink">
                                                            <button class="text-center button primary round expanded check-zip-btn" @click="checkZip()"><span>Go</span></button>
                                                      </div>
                                                </div>
                                                <div class="grid-x grid-padding-x align-center">
                                                      <div class="cell small-12 medium-8">
                                                            <p class="mb0 mt32 text-center" style="font-size:1rem;"><router-link to="/" class="underline">Back</router-link> to the main page.</p>
                                                      </div>
                                                </div>
                                          </div>
                                          <div class="grid-x grid-padding-x align-center"  v-else-if="questionIndex===3 || questionIndex===6 || questionIndex===7 || questionIndex===8 || questionIndex===9"></div>
                                          <div  v-else-if="questionIndex===1">
                                                <div class="grid-x grid-padding-x align-center mb24" >
                                                      <div class="cell small-12 large-8">
                                                            <div class="custom-select">
                                                                  <div class="selection-drop-btn button round option-btn" @click="dropDown()"><span>Yes</span> - Select the state from which your employer purchases plans <img src="img/down-arrow.png" width="20"/></div>
                                                                  <div class="selection-items animate__animated animate__fast" :class="[dropClass ? 'show-drop' : 'hide-drop']">
                                                                        <div v-for="link in deepLinks" :key="link.state">
                                                                              <a @click="openLink(link.link);" target="_blank">{{link.state}}</a>
                                                                        </div>
                                                                  </div>
                                                            </div>
                                                      </div>
                                                </div>
                                                <div class="grid-x grid-padding-x align-center mb40" >
                                                      <div class="cell small-12 large-8">
                                                            <a class="text-left button primary round expanded option-btn second" @click="no()"><span>No</span> - I will see any {{sloganIn}} doctor </a>
                                                      </div>
                                                </div>
                                                <p class="mb0 text-center bottom-text">Choosing "yes" will open a new window with our Find a Doctor tool. Please search to see if your doctor participates in {{sloganIn}}, then return to this screen to complete the quiz. You can search by specialty, name, or license number.</p>
                                          </div>
                                          <div v-else-if="questionIndex===4">
                                                <div class="grid-x grid-padding-x align-center mb40" >
                                                      <div class="cell shrink">
                                                            <a class="button primary round expanded" @click="yes()"><span>Continue >></span></a>
                                                      </div>
                                                </div>
                                                <p class="mb0 text-center bottom-text">{{questions[questionIndex].ps}}</p>
                                          </div>
                                          <div class="grid-x grid-padding-x align-center mb24" v-else>
                                                <div class="cell small-9 medium-3 large-3 btn-small">
                                                      <a class="button primary round expanded" @click="yes()"><span>Yes</span></a>
                                                </div>
                                                <div class="cell medium-1 large-1"></div>
                                                <div class="cell small-9 medium-3 large-3">
                                                      <a class="button primary round expanded" @click="no()"><span>No</span></a>
                                                </div>
                                          </div>
                                    </div>
                              </transition>
                        </div>
                  </div>
            </div>
      </div>
</template>

<script>
      import jsonZip from '../json/zip-codes-new.json'

      export default {
            name: "AnthemLinkEvaluation",
            data() {
                  let sloganOut = 'Anthem Link'
                  return {
                        sloganIn: 'Anthem Link',
                        quizTitle: 'Check if ' + sloganOut + ' is right fit for you',
                        serviceUrl: process.env.VUE_APP_SERVICE_URL,
                        questionIndex: 0,
                        zipCode: null,
                        zipCodes: jsonZip,
                        zipClass:"", 
                        dropClass:false,
                        goClass: "show",
                        spinClass: "hide",
                        startDateYear: "",
                        endDateYear: "",
                        thisDateYear:"",
                        questions: [
                              {
                                    number: 0,
                                    name: sloganOut + ' Evaluation Quiz',
                                    path: '',
                                    theme: "animate0",
                                    title: "To determine if " + sloganOut + " could be a good fit for your needs, check to see if it’s available in your area.",
                                    text: "If you or family members seek/receive care in multiple areas (your current residential address, college campus, travel, etc.), check below to see if " + sloganOut + " is available in each location."
                              },
                              {
                                    number: 1,
                                    name: 'Available ZIP Code',
                                    path: '/available-zip-code',
                                    theme: "animate1",
                                    title: "<span class='subtitle'>Good news: " + sloganOut + " is available in your area.</span> Do you have preferred doctors, specialists, or hospitals?",
                              },
                              {
                                    number: 2,
                                    name: 'Has Preferred Providers',
                                    path: '/has-preferred-providers',
                                    theme: "animate2",
                                    title: "<span style='margin-bottom:100px;display:block;'>Is your preferred doctor or<br class='break'/> hospital in our network?</span>"
                              },
                              {
                                    number: 3,
                                    name: 'Provider Is In-Network - GEO + Provider',
                                    path: '/provider-is-in-network-geo-provider',
                                    theme: "animate3",
                                    icon: "img/right.png",
                                    title: "<strong> " + sloganOut + " could be a good choice<br class='break'/> for you and your family!</strong>",
                                    text: "<span><strong> " + sloganOut + " offers:</strong></span><span>High quality doctors and national access</span><span>Symptom checker guiding your care</span><span>$0 virtual visits through interactive chat or video*</span>",
                                    ps: "*Non-HSA plans. Applies to HSA plans after members have met their deductible."
                              },
                              {
                                    number: 4,
                                    name: 'Provider Is Not In-Network',
                                    path: '/provider-is-not-in-network',
                                    theme: "animate4",
                                    title: "We have curated a list of doctors and hospitals that might be a great option for you and your family’s needs.",
                                    text: "<span><strong>You are covered with " + sloganOut + " :</strong></span><span>Symptom Checker to guide your care</span><span>$0 virtual visits via interactive chat or video*</span>",
                                    ps: "*Non-HSA plans. Applies to HSA plans after members have met their deductible."
                              },
                              {
                                    number: 5,
                                    name: 'Continue To Explore Providers',
                                    path: '/continue-to-explore-providers',
                                    theme: "animate5",
                                    title: "<span style='margin-bottom:100px;display:block;'>Are you interested in exploring other high quality doctors and hospitals in our network?</span>"
                              },
                              {
                                    number: 6,
                                    name: 'Is A Fit - GEO + Explore New Provider',
                                    path: '/is-a-fit-geo-explore-new-provider',
                                    theme: "animate6",
                                    icon: "img/right.png",
                                    title: "<strong> " + sloganOut + " could be a great option<br class='break'/> for you and your family!</strong>",
                                    text: "<p>To search for a doctor in the Blue HPN<sup>SM</sup> network near you,<br class='break'/> visit our website to use the <a href='https://www.anthem.com/find-care/' class='underline' target='_blank'>Find a Doctor tool</a>.</p>"
                              },
                              {
                                    number: 7,
                                    name: 'Not A Fit - GEO',
                                    path: '/not-a-fit-geo',
                                    theme: "animate7",
                                    icon: "img/error.png",
                                    title: "<strong>Thank you for your interest in " + sloganOut + ".</strong>",
                                    text: "Anthem Link is currently not available in your location. We are expanding the network and hope to offer more top doctors and hospitals soon. Please be sure to check again during your next enrollment for your chance to lower your out-of-pocket costs or refer to your open enrollment information to see if there are other Anthem products that could be right for you."
                              },
                              {
                                    number: 8,
                                    name: 'Not A Fit - Providers',
                                    path: '/not-a-fit-providers',
                                    theme: "animate8",
                                    icon: "img/error.png",
                                    title: "<strong> " + sloganOut + " includes $0 virtual visits, but may<br class='break'/> not be what you are currently looking for.*</strong>",
                                    text: "Anthem Link is currently not available in your location. We are expanding the network and hope to offer more top doctors and hospitals soon. Please be sure to check again during your next enrollment for your chance to lower your out-of-pocket costs or refer to your open enrollment information to see if there are other Anthem products that could be right for you.",
                                    ps: "*Non-HSA plans. Applies to HSA plans after members have met their deductible."
                              },
                              {
                                    number: 9,
                                    name: 'Is A Fit - No Preferred Providers',
                                    path: '/is-a-fit-no-preferred-providers',
                                    theme: "animate8",
                                    icon: "img/right.png",
                                    title: "<strong> " + sloganOut + " could be a good choice<br class='break'/> for you and your family!</strong>",
                                    text: "<span><strong> " + sloganOut + " offers:</strong></span><span>High quality doctors and national access</span><span>Symptom checker guiding your care</span><span>$0 virtual visits through interactive chat or video*</span>",
                                    ps: "*Non-HSA plans. Applies to HSA plans after members have met their deductible."
                              }
                        ],
                        deepLinks:[
                              {
                                    state: "California",
                                    link: "https://www.anthem.com/find-care/?alphaprefix=2506"
                              },
                              {
                                    state: "Colorado",
                                    link: "https://www.anthem.com/find-care/?alphaprefix=2232"
                              },
                              {
                                    state: "Georgia",
                                    link: "https://www.anthem.com/find-care/?alphaprefix=1627"
                              },
                              {
                                    state: "Indiana",
                                    link: "https://www.anthem.com/find-care/?alphaprefix=1720"
                              },
                              {
                                    state: "Kentucky",
                                    link: "https://www.anthem.com/find-care/?alphaprefix=1834"
                              },
                              {
                                    state: "Maine",
                                    link: "https://www.anthem.com/find-care/?alphaprefix=1229"
                              },
                              {
                                    state: "Missouri",
                                    link: "https://www.anthem.com/find-care/?alphaprefix=1916"
                              },
                              {
                                    state: "Nevada",
                                    link: "https://www.anthem.com/find-care/?alphaprefix=2330"
                              },
                              {
                                    state: "New Hampshire",
                                    link: "https://www.anthem.com/find-care/?alphaprefix=1327"
                              },
                              {
                                    state: "Ohio",
                                    link: "https://www.anthem.com/find-care/?alphaprefix=2009"
                              },
                              {
                                    state: "Virginia",
                                    link: "https://www.anthem.com/find-care/?alphaprefix=1526"
                              },
                              {
                                    state: "Wisconsin",
                                    link: "https://www.anthem.com/find-care/?alphaprefix=2121"
                              },
                        ]
                  }
            },
            methods: {
                  yes() {
                        if (this.questionIndex < this.questions.length) this.questionIndex++
                  },
                  no() {
                        switch (this.questionIndex){
                              case 1:
                                    this.questionIndex = 9
                                    break
                              case 2:
                                    this.questionIndex = 4
                                    break
                              case 5:
                                    this.questionIndex = 8
                                    break
                              default:
                                    this.questionIndex--
                        }
                  },
                  openLink(url){
                        this.dropClass = !this.dropClass
                        let message = 'Choosing "yes" will open a new window with our Find a Doctor tool. Please search to see if your doctor participates in ' + this.sloganIn + ', then return to this screen. You can search by specialty, name, or license number.'
                        this.$fire({
                              html: message,
                              showCancelButton: true
                        }).then((result) => {
                              if(result.value){
                                    window.open( url, "_blank")
                                    if (this.questionIndex == 10 || this.questionIndex == 11) this.questionIndex = 2
                                    else if (this.questionIndex < (this.questions.length-1)) this.questionIndex++
                              }
                        })
                  },
                  checkZip() {
                        let zip = parseInt(this.zipCode)
                        let correctZip = this.zipCodes.indexOf(zip)
                        if(zip===null || isNaN(zip) || !zip || this.zipCode.length < 5) 
                              this.zipClass = "animate__shakeX error-show"
                        else
                              if(correctZip != -1) this.questionIndex = 1
                              else this.questionIndex = 7
                  },
                  goBack(){
                        this.questionIndex = 0
                        this.zipCode=""
                        this.zipClass=""
                  },
                  dropDown(){
                        this.dropClass = !this.dropClass
                  },
                  track(label) {
                        this.$gtag.event('Click', {
                              'event_category': 'CTA',
                              'event_label': label,
                              'value': 1
                        })
                  },
                  pageView(title, path){
                        this.$gtag.pageview({
                              page_title: title,
                              page_path: '/evaluation' + path
                        })
                  }
            },
            watch: {
                  questionIndex(){
                        let pageTitle = this.questions[this.questionIndex].name
                        let pagePath = this.questions[this.questionIndex].path
                        this.pageView(pageTitle, pagePath)
                  }
            }
      };
</script>

<style lang="scss">
      .half-circle-spinner{
            margin: 0 auto;
            position: absolute !important;
            top:50%;
            left: 50%;
            transform: translate(-50%,-50%);
      }
      .show{
            display:block !important;
      }
      .hide{
            display: none !important;
      }
      .swal2-styled.swal2-confirm, .swal2-styled.swal2-cancel{
            outline: none !important;
            box-shadow: none !important;
      }
      .swal2-content #swal2-content{
            font-size: 0.875rem !important;
            font-family: "TV Nord EF", "Helvetica Neue", Arial, sans-serif !important;
            font-weight: 400;
            line-height: 1.6;
      }
      #quiz-content{
            margin-top:80px;
            .underline{
                  text-decoration: underline;
            }
            .animate__shakeX{
                  border-color:red !important;
            }
            .alert-banner{
                  background: #d91a47;
                  width: 100%;
                  position: fixed;
                  top: 52px;
                  padding: 10px;
                  margin: 0;
                  left: 0;
                  text-align: center;
                  color: #ffffff;
                  p{
                        margin-bottom: 0px !important;
                        font-size: 20px;
                        font-weight: 600;
                  }
            }
            &.available-zip-code---termination-date{
                  #questions{
                        .question-container{
                              top:40px;
                        }
                  }
            }
            #questions{
                  .detect-overlay{
                        position: absolute;
                        width: 100%;
                        height: 100%;
                        top: 0;
                        left: 0;
                        background-color: transparent;
                        z-index: 3;
                  }
                  .question-container{
                        border:solid 4px #f38021;
                        max-width: 900px;
                        border-radius: 0px;
                        margin: 0 auto;
                        padding:40px;
                        position:relative;
                        min-height: 630px;
                        transition: all 0.2s ease-in-out 0s;
                        h1{
                              font-size: 1.65rem !important;
                              color:#1779ba;
                              position:absolute;
                              left:50%;
                              top:19%;
                              transform: translate(-50%, -50%);
                              span{
                                    font-weight: 600;
                                    display: block;
                                    opacity: 0.8;
                                    margin-bottom: 0px !important;
                                    font-size: 75%;
                              }
                        }
                        h2{
                              font-size: 1.75rem !important;
                              margin-bottom: 1.5rem !important;
                              font-weight: 400;
                              .subtitle{
                                    display: block;
                                    font-size:1.5rem;
                                    margin-bottom: 16px;
                                    font-weight: 600;
                                    color:#f38021;
                              }
                        }
                        p{
                              font-family: "TV Nord EF", "Helvetica Neue", Arial, sans-serif !important;
                              font-weight: 400;
                              font-size: 1.125rem;
                              &.subtext{
                                    margin-bottom: 1.5rem !important;
                                    span{
                                          display: block;
                                          margin-bottom:0px;
                                    }
                              }
                              &.error{
                                    font-size: 0.875rem;
                                    color:red; 
                                    text-align:center;
                                    margin-top: 4px;
                                    margin-bottom:0px !important;
                                    opacity: 0;
                                    transition: all 0.2s ease-in-out 0s;
                                    &.error-show{
                                          opacity: 1;
                                    }
                              }
                              &.bottom-text{
                                    font-size: 0.875rem;
                              }
                        }
                        .question{
                              position:absolute;
                              left:50%;
                              top:62%;
                              transform: translate(-50%, -50%);
                              width:80%;
                              z-index: 4;
                              .question-icon{
                                    color:#f38021;
                                    font-size: 96px;
                              }
                              .button{
                                    margin-bottom:0px;
                                    height: 100%;
                                    font-size: 1.125rem;
                                    padding: 8px 16px;
                                    line-height: 28px;
                                    &.option-btn{
                                          font-weight: 400;
                                          padding-bottom: 4px;
                                    }
                                    span{
                                          font-weight: 600;
                                          font-size: 1.25rem;
                                    }
                                    img{
                                          position: absolute;
                                          right: 5%;
                                          top: 50%;
                                          transform: translateY(-50%)
                                    }
                              }
                              .round{
                                    border-radius:4px;
                                    padding-bottom:4px;
                              }
                              .check-zip-btn{
                                    width:62px;
                                    height:54px;
                                    position:relative;
                                    span{
                                          font-size: 1.5rem; 
                                    }
                              }
                              input{
                                    text-align: center;
                                    box-shadow: none;
                                    border-color:#1779ba;
                                    border-radius: 6px;
                                    font-size: 24px;
                                    height: inherit;
                                    margin-bottom:0px;
                                    transition: all 0.2s ease-in-out 0s;
                                    &.error-show{
                                          box-shadow: 0px 0px 6px rgba(255,34,0,0.4);
                                    }
                              }
                              .custom-select{
                                    position: relative;
                                    width:100%;
                                    z-index: 5;
                              }
                              .selection-drop-btn{
                                    width: 100%;
                                    text-align: left; 
                              }
                              .selection-items{
                                    position: absolute;
                                    background-color: #58b6e7; 
                                    width: 100%;
                                    border-radius: 4px;
                                    display: none;
                                    &.hide-drop{
                                          display: none;
                                    }
                                    &.show-drop{
                                          display: block;
                                    }
                                    a{
                                          padding:8px 16px;
                                          color:#ffffff;
                                          display: block;
                                          font-size: 1.25rem;
                                          border-bottom: solid 1px rgba(17,97,149,0.3);
                                          &:hover{
                                                background-color: rgba(17,97,149,1);
                                          }
                                    }
                                    div{
                                          &:last-child{
                                                a{
                                                      border:none;
                                                }
                                          }
                                    }
                              }
                        }
                        .progress-container{
                              width: 40%;
                              margin: 8px auto 0px;
                              border-radius: 10px;
                               .progress{
                                    height: 0.75rem;
                                    width: 18.72%;
                                    display: inline-block;
                                    margin-right:1.6%;
                                    border-radius: 10px; 
                                    background-color: #e9e9e9;
                                    .progress-meter {
                                          background-color: transparent;
                                          border-radius: 10px;
                                          width: 100%;
                                    }
                                    &:last-child{
                                          margin-right:0;
                                    }
                              }
                              &.animate0{
                                    .progress-meter1{
                                          background-color: #58b6e7;
                                          animation: move 0.5s linear 1;
                                    }
                              }
                              &.animate1{
                                    .progress-meter1{
                                          background-color: #58b6e7;
                                    }
                                    .progress-meter2{
                                          background-color: #58b6e7;
                                          animation: move 0.5s linear 1;
                                    }
                              }
                              &.animate2{
                                     .progress-meter1{
                                          background-color: #58b6e7;
                                    }
                                    .progress-meter2{
                                          background-color: #58b6e7;
                                    }
                                    .progress-meter3{
                                          background-color: #58b6e7;
                                          animation: move 0.5s linear 1;
                                    }
                              }
                              &.animate4, &.animate5{
                                     .progress-meter1{
                                          background-color: #58b6e7;
                                    }
                                    .progress-meter2{
                                          background-color: #58b6e7;
                                    }
                                    .progress-meter3{
                                          background-color: #58b6e7;
                                    }
                                    .progress-meter4{
                                          background-color: #58b6e7;
                                          animation: move 0.5s linear 1;
                                    }
                              }
                              &.animate3, &.animate6, &.animate7, &.animate8{
                                     .progress-meter1{
                                          background-color: #58b6e7;
                                    }
                                    .progress-meter2{
                                          background-color: #58b6e7;
                                    }
                                    .progress-meter3{
                                          background-color: #58b6e7;
                                    }
                                    .progress-meter4{
                                          background-color: #58b6e7;
                                    }
                                    .progress-meter5{
                                          background-color: #58b6e7;
                                          animation: move 0.5s linear 1;
                                    }
                              }
                        }
                  }
            }
      }
      @keyframes move {
            0% {
                  width: 0%;
            }
            100% {
                  width: 100%;
            }
      }
      @media only screen and (max-width:1680px){
            #quiz-content{
                  margin-top:80px;
            }
            #quiz-content #questions{
                  height: inherit;
            }
            .question-container{
                  padding: 40px;
                  min-height: 630px !important;
            }
      }
      @media only screen and (max-width:1460px){
            #quiz-content #questions{
                  height: inherit;
            }
            
            #quiz-content #questions .question-container .question .button.option-btn,
            #quiz-content #questions .question-container .question .button .fa-caret-down{
                  line-height: 32px;
            }
      }
      @media only screen and (max-width: 1280px){
            .break{
                  display: none;
            }
            #quiz-content{
                  margin-top:40px;
            }
             .question-container{
                  min-height: inherit !important;
            }
            .question, #quiz-content #questions .question-container h1{
                  position: inherit !important;
                  left: 0 !important;
                  top:0 !important;
                  transform: none !important; 
                  width:100% !important;
            }
      }
      @media only screen and (max-width:1024px){
            .question-container{
                  border-radius:0px !important;
                  padding:60px 40px !important;
            }
            .swal2-popup{
                  background: #ffffff !important;
            }
      }
      @media only screen and (max-width:740px){
            .alert-banner{
                  padding: 14px !important;
                  p{
                        font-size: 15px !important;
                  }
            }
            #quiz-content #questions .question-container .progress-container{
                  width:60%;
            }
            .question-container{
                  padding:32px 16px !important;
            }
            .question, #quiz-content #questions .question-container h1{
                  font-size: 1.5rem !important;
            }
            .question, #quiz-content #questions .question-container h2{
                  font-size: 1.375rem !important;
            }
            .question, #quiz-content #questions .question-container p.subtext{
                  font-size: 1rem !important;
            }
            #quiz-content #questions .question-container p.bottom-text{
                  line-height: 1.3;
            }
      }
      @media only screen and (max-width:640px){
            #quiz-content #questions .question-container .question .check-zip-btn{
                  margin-top:8px;
                  width: 100%;
            }
            .btn-small{
                  margin-bottom:24px; 
            }
            #quiz-content #questions .question-container .question .button.option-btn,
            #quiz-content #questions .question-container .question .button .fa-caret-down{
                  font-size: 1.125rem;
                  padding:8px 10px;
                  padding-bottom:4px;
            }
      }
      @media only screen and (max-width:420px){
            .question-container{
                  padding:24px 16px !important;
            }
            .question, #quiz-content #questions .question-container h1{
                  font-size: 1.5rem !important;
                  margin-bottom: 16px !important;
            }
            .question, #quiz-content #questions .question-container h2{
                  margin-bottom: 24px !important;
            }
            .question, #quiz-content #questions .question-container p.subtext{
                  margin-bottom: 24px !important;
            }
            #quiz-content #questions .question-container .question .question-icon{
                  margin-bottom: 0px !important;
            }
      }
</style>
